import script from "./InscriptionAttachments.vue?vue&type=script&setup=true&lang=js"
export * from "./InscriptionAttachments.vue?vue&type=script&setup=true&lang=js"

import "./InscriptionAttachments.vue?vue&type=style&index=0&id=2c47d634&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c47d634"]])

export default __exports__